import React, { useState } from 'react';
import { Copy } from 'react-feather';

const TextEditorViewer = (props) => {
    const [copiedItems, setCopiedItems] = useState(new Set());
    const handleCopy = (text, index) => {
        const textarea = document.createElement('textarea');
        const valueToCopy = text.split(':').slice(1).join(':').trim(); // Get everything after the first colon
        textarea.value = valueToCopy; // Set the specific text to copy
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea); 
        setCopiedItems((prev) => new Set(prev).add(index));
    };

    const content = props.data.split(/<\/?p>|<\/?h4>|<div>&nbsp;<\/div>/).filter(item => item.trim() !== ''); // Filter out empty strings and divs with &nbsp;

    return (
        <div className="body-container">
            <div className="body">
                {content.map((item, index) => {
                    const cleanText = item.replace(/<\/?[^>]+(>|$)/g, "").trim(); // Clean text for display

                    return (
                        <div key={index} style={{ marginBottom: '10px',fontSize: 14 ,display: 'flex', alignItems: 'center' }}>
                            <div dangerouslySetInnerHTML={{ __html: item }} style={{ flex: 1 }} />
                            {copiedItems.has(index) && <span style={{ marginLeft: '10px', color: 'green' }}></span>}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TextEditorViewer;
